import { Navigate, Outlet } from "react-router";

// import Approval from "../components/Programs/ApprovalSteps";

const ProtectedRoutes = () => {
  return localStorage.getItem("user_id") ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
